import React from 'react';
import './SubSection.css';

function SubSection(props) {
  const {
    itemId,
    title,
    link,
    newSection,
    depthLevel,
    hideLink,
    first,
    virtualTitle,
    viewAll,
    symbol,
  } = {...props};

  const isLikeNew = symbol === 'kak-novyy';

  const titleClass = `flex gap-2 text-[13px] min-1401:text-[14px] leading-[18px] text-blue-primary`;
  const linkClass = `flex gap-2 text-[13px] min-1401:text-[14px] leading-[18px] mt-1.5 ${viewAll ? 'text-[#898989]' : 'text-grey-90'}`;

  const itemClass = (Number(depthLevel) === 2 || virtualTitle) && !viewAll ?
    titleClass : linkClass;

  return (
    <li className={`${Number(depthLevel) === 2 && !first ? 'pt-4' : ''}`}>
      {
        hideLink ?
          <span className={`${itemClass} ${isLikeNew ? 'submenu-like-new' : ''}`} key={itemId}>
            <span className={isLikeNew ? 'submenu-like-new__title' : ''}>{title}</span>
            {isLikeNew && <span className="submenu-like-new__icon" aria-hidden="true"/>}
          </span> :
          <a href={link} className={`${itemClass} ${isLikeNew ? 'submenu-like-new' : ''}`} key={itemId}>
            <span
              className={`hover:underline hover:underline-offset-2 hover:decoration-blue-primary hover:text-blue-primary ${isLikeNew ? 'submenu-like-new__title' : ''}`}>{title}</span>
            {isLikeNew && <span className="submenu-like-new__icon" aria-hidden="true"/>}
            {
              newSection && (
                <span className="self-start text-[10px] leading-[15px] font-medium italic text-red-mistake">new</span>
              )
            }
          </a>
      }
    </li>
  );
}

export default SubSection;